export class WidgetExtendedConfigJSON {
  displayUserOrCompanyName?: boolean | null;
  plasticDisplayFormat?: "plastic_kg" | "plastic_bottles" | null;
}
